import { Marker } from 'mapbox-gl';
import { loadAndAddImage } from '../image_helpers';

const mapMarkerImageId = color => {
  return `map-marker-${color}`;
};

const mapMarkerImageSrc = color => {
  return `https://cdn-assets.alltrails.com/assets/icons/maps/markers/map-marker-${color}@2x.png`;
};

const mapMarkerDiv = color => {
  const div = document.createElement('div');
  div.style.backgroundImage = `url("${mapMarkerImageSrc(color)}")`;
  div.style.backgroundSize = 'contain';
  if (['start', 'end'].includes(color)) {
    div.style.height = '40px';
    div.style.width = '40px';
  } else {
    div.style.height = '30px';
    div.style.width = '30px';
  }
  return div;
};

const createDraggableMarker = color => {
  const element = mapMarkerDiv(color);
  return new Marker({
    element,
    draggable: true
  });
};

const addMarkerImagesToMap = (map, color) => {
  const imageId = mapMarkerImageId(color);
  const imageSrc = mapMarkerImageSrc(color);
  return loadAndAddImage(map, imageId, imageSrc, {
    pixelRatio: 2
  });
};

const createMarkerLayer = (id, sourceId, color) => {
  return {
    id,
    type: 'symbol',
    source: sourceId,
    layout: {
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
      'icon-anchor': ['coalesce', ['get', 'iconAnchor'], 'center'],
      'icon-image': ['image', ['coalesce', ['get', 'iconImage'], mapMarkerImageId(color)]],
      'symbol-z-order': 'source'
    }
  };
};

export { addMarkerImagesToMap, createMarkerLayer, mapMarkerImageId, mapMarkerImageSrc, mapMarkerDiv, createDraggableMarker };
